import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { chapters } from '../content/chapters';
import ChapterCard from '../components/ChapterCard';
import Mascot from '../components/Mascot';

export default function Browse() {
  const [openChapter, setOpenChapter] = useState<number | null>(null);
  const navigate = useNavigate();

  const pickSection = (id: string, title: string) => {
    sessionStorage.setItem(
      'mb_input',
      JSON.stringify({
        text: `Generate a typical ${title} problem (Chapter ${id}) for 6th-grade level using imperial units (inches, feet, yards — no metric), then walk through it.`,
        source: 'browse',
        chapter: id,
      })
    );
    navigate('/solve');
  };

  return (
    <div className="max-w-xl mx-auto px-5 pt-10 safe-top space-y-6">
      <header className="flex items-center gap-3">
        <Mascot mood="happy" size={56} />
        <div>
          <h1 className="font-display font-black text-2xl leading-none">Browse chapters</h1>
          <p className="text-ink/70 text-sm">Big Ideas Math — Course 1</p>
        </div>
      </header>

      <div className="grid grid-cols-2 gap-3">
        {chapters.map((c) => (
          <ChapterCard
            key={c.num}
            chapter={c}
            onClick={() => setOpenChapter(openChapter === c.num ? null : c.num)}
          />
        ))}
      </div>

      {openChapter && (
        <div className="card p-5 space-y-3">
          <div className="font-display text-lg">
            Chapter {openChapter}: {chapters[openChapter - 1].title}
          </div>
          <div className="space-y-2">
            {chapters[openChapter - 1].sections.map((s) => (
              <button
                key={s.id}
                onClick={() => pickSection(s.id, s.title)}
                className="w-full flex items-center justify-between p-3 rounded-xl bg-cream hover:bg-coral/5 transition text-left"
              >
                <span>
                  <span className="math-display text-sm text-ink/60 mr-3">{s.id}</span>
                  {s.title}
                </span>
                <span>→</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
